import { render, staticRenderFns } from "./duration.vue.html?vue&type=template&id=61277488"
import script from "./duration.controller.ts?vue&type=script&lang=js&external"
export * from "./duration.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports